import { GET, POST } from "../axios/Axios";
import { URL } from "../../api/Api";
import { catchError } from "../axios/Axios";

export const GetInterviewkitData = async (matchId) => {
  try {
    const response = await GET(
      `${URL}/matchengine/pre-screen-questions/${matchId}`
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const UpdateInterviewkitData = async (matchId, data) => {
  try {
    const response = await POST(
      `${URL}/matchengine/pre-screen-questions/${matchId}`,
      data
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};
